module.exports = __webpack_public_path__ + "img/thumbs-down-solid.f885c8b4.svg";